import React from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../SectionHeader";

const FAQS = [
  {
    q: "How long does implementation take?",
    a: "Most single-location businesses go live in 2–4 weeks. Larger rollouts follow a structured plan — Byteflow School, for example, takes a school fully live in 45 days, customised and data-migrated, before the next term starts.",
  },
  {
    q: "Can you migrate data from Tally, Excel, or our current software?",
    a: "Yes. Guided migration is part of every onboarding — masters, opening balances, stock, and historical transactions where the source system allows export.",
  },
  {
    q: "Is Byteflow cloud-based or on-premise?",
    a: "Both. Cloud hosting is the default for fast starts; on-premise deployment is available on Enterprise plans for businesses with their own infrastructure or compliance needs.",
  },
  {
    q: "Do you support GST filing and e-way bills?",
    a: "GST-ready invoicing, GSTR-friendly reports, and e-way bill generation are built into every product that touches billing.",
  },
  {
    q: "What does support look like after go-live?",
    a: "Phone, WhatsApp, and email support in your timezone, with priority and dedicated-manager tiers on higher plans. Training refreshers are free.",
  },
];

const HomeFaq = () => (
  <section className="section">
    <SectionHeader
      eyebrow="FAQ"
      title="Questions we hear most"
    />
    <div className="faq-list">
      {FAQS.map((f) => (
        <details key={f.q} className="faq-item">
          <summary>
            {f.q}
            <span className="faq-item__chevron" aria-hidden>+</span>
          </summary>
          <p>{f.a}</p>
        </details>
      ))}
    </div>
    <p className="faq-footer">
      Have a different question? <Link to="/contact">Talk to our team</Link> —
      we reply within one business day.
    </p>
  </section>
);

export default HomeFaq;
